import { BreakPoint } from '../constants/platform';

export const mediaQuery = (width: number, option: 'max' | 'min' = 'max') =>
  `@media (${option}-width: ${width}px)`;

const media = {
  tablet: mediaQuery(BreakPoint.TABLET),
  mobile: mediaQuery(BreakPoint.MOBILE),
  minMobile: mediaQuery(BreakPoint.MOBILE + 1, 'min'),
  custom: mediaQuery,
};

export default media;
